import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { ROUTES, APP } from '@/lib/constants'

/**
 * /login — Por ahora redirige a tax-account OAuth flow.
 *
 * El flow real es:
 *   1. User click "Iniciar sesión con tax-account"
 *   2. Redirect a {APP.accountUrl}/oauth/authorize?client_id=...
 *   3. tax-account autentica + redirect a /oauth/callback con code
 *   4. /oauth/callback intercambia code por JWT y guarda en memoria
 *   5. Redirect a /dashboard
 *
 * Pendiente: implementar /oauth/callback page + wire OIDC con tax-account.
 * Por ahora muestra mensaje + link directo al tax-account login.
 */
export function LoginPage() {
  return (
    <div className="min-h-screen bg-bg-base text-fg-primary">
      <header className="border-b border-border">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to={ROUTES.LANDING} className="inline-flex items-center gap-1.5 text-sm text-fg-muted hover:text-fg-primary">
            <ArrowLeft className="h-4 w-4" />
            Volver
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-md px-6 py-16">
        <h1 className="text-2xl font-bold">Iniciar sesión</h1>
        <p className="mt-2 text-sm text-fg-secondary">
          Taxor usa la cuenta tax-account para autenticar partners.
        </p>

        <div className="mt-6 rounded-xl border border-border bg-bg-surface p-6">
          <a
            href={`${APP.accountUrl}/login?redirect_to=${encodeURIComponent(window.location.origin + ROUTES.DASHBOARD)}`}
            className="block w-full rounded-md bg-brand-600 px-4 py-2.5 text-center text-sm font-semibold text-white hover:bg-brand-700"
          >
            Continuar con tax-account
          </a>
          <p className="mt-3 text-xs text-fg-muted">
            ¿No tienes cuenta de partner?{' '}
            <Link to={ROUTES.SIGNUP} className="text-brand-600 underline">
              Regístrate
            </Link>
          </p>
        </div>

        <div className="mt-6 rounded-md border border-yellow-300 bg-yellow-50 p-4 text-xs text-yellow-900 dark:bg-yellow-950 dark:text-yellow-100 dark:border-yellow-800">
          <strong>Nota técnica:</strong> El callback OAuth + intercambio de code por JWT
          aún no está cableado en este MVP. Para pruebas locales, setea el JWT en
          localStorage manualmente o usa el endpoint{' '}
          <code className="font-mono">/login</code> del tax-account.
        </div>
      </main>
    </div>
  )
}
